import UploaderInstallOrderInstallImage from './uploader-install-order-install-image.vue'
export default UploaderInstallOrderInstallImage
